import { Container } from '@mui/material';
import React, { useEffect } from 'react';
import { Cart } from '../components/Cart';
import PageTransition from '../components/PageTransition';

export const CartPage: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <PageTransition>
      <Container sx={{ py: 4, minHeight: 'calc(100vh - 64px)' }}>
        <Cart />
      </Container>
    </PageTransition>
  );
};
